import { useState, useCallback } from 'react';
import * as branchManagementAction from "../redux/store-sarang/branch/branch-management.store";

export const useLookupBranch = () => {
    const [branch, setBranch] = useState([]);

    const getLookupBranch = useCallback(async () => {
        try {
            const res = await branchManagementAction.GetLookupBranch();
            if (res && res.content) {
                setBranch(res.content);
                return res.content;
            }
            return [];
        } catch (err) {
            console.error(err);
            throw err;
        }
    }, []);

    return { branch, getLookupBranch };
};
